import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

/**
 * Stufenanzeige: three segments for im Aufbau · sicher · gefestigt, a ✓ for
 * "bestätigt", the level's name next to it — never a percentage bar. One
 * image for screen readers (`role="img"`, `label` + level).
 */
@Component({
  selector: 'app-level-meter',
  template: `
    <span class="meter" role="img" [attr.aria-label]="label">
      <span class="seg" *ngFor="let s of segments" [class.on]="s <= level" aria-hidden="true"></span>
      <span class="check" *ngIf="verified" aria-hidden="true">✓</span>
    </span>
    <span class="text" *ngIf="showLabel" aria-hidden="true">{{ label }}</span>
  `,
  styleUrl: './level-meter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LevelMeterComponent {
  /** 0..3 */
  @Input() level = 0;
  @Input() verified = false;
  @Input() label = '';
  @Input() showLabel = true;
  /** quieter look for an axis that is not captured */
  @Input() @HostBinding('class.is-muted') muted = false;

  readonly segments = [1, 2, 3];
}
